import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { Code } from './proto';
export var ERRORS_NONFATAL = [Code.UNAVAILABLE, Code.UNKNOWN, Code.DEADLINE_EXCEEDED, Code.UNIMPLEMENTED, Code.INTERNAL, Code.DATA_LOSS, Code.OUT_OF_RANGE, Code.ABORTED];

var RoundRobin = /*#__PURE__*/function () {
  function RoundRobin() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        minDelay = _ref.minDelay,
        maxDelay = _ref.maxDelay;

    _classCallCheck(this, RoundRobin);

    this.MIN_DELAY = 200;
    this.MAX_DELAY = 15000;
    this.nextDelay = this.MIN_DELAY;
    this.requestSucceeded = true;

    if (minDelay) {
      this.MIN_DELAY = minDelay;
      this.nextDelay = minDelay;
    }

    if (maxDelay) {
      this.MAX_DELAY = maxDelay;
    }
  }

  _createClass(RoundRobin, [{
    key: "retry",
    value: function retry(handler, status) {
      var _this = this;

      this.cancelSuccessTimeout();

      if (RoundRobin.enabled && (status && 'code' in status ? status.code && ERRORS_NONFATAL.includes(status.code) : !this.requestSucceeded)) {
        var delay = this.delay;
        this.roundRobinTimeoutId = setTimeout(function () {
          _this.roundRobinTimeoutId = undefined;
          handler();
        }, delay);
        this.nextDelay = Math.min(delay * 2, this.MAX_DELAY);
        return delay;
      }

      if (!status) {
        handler();
        return 0;
      }

      return -1;
    }
  }, {
    key: "delay",
    get: function get() {
      return this.nextDelay;
    }
  }, {
    key: "isActive",
    get: function get() {
      return this.roundRobinTimeoutId != null;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.nextDelay = this.MIN_DELAY;
      this.cancelSuccessTimeout();
      this.requestSucceeded = true;
    }
  }, {
    key: "startSuccessTimeout",
    value: function startSuccessTimeout() {
      var _this2 = this;

      this.requestSucceeded = false;
      this.requestSuccessTimeoutId = setTimeout(function () {
        _this2.requestSucceeded = true;
      }, 1000);
    }
  }, {
    key: "cancelSuccessTimeout",
    value: function cancelSuccessTimeout() {
      if (this.requestSuccessTimeoutId != null) {
        clearTimeout(this.requestSuccessTimeoutId);
        this.requestSuccessTimeoutId = undefined;
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.roundRobinTimeoutId != null) {
        clearTimeout(this.roundRobinTimeoutId);
        this.roundRobinTimeoutId = undefined;
      }

      this.cancelSuccessTimeout();
    }
  }], [{
    key: "disable",
    value: function disable() {
      this.enabled = false;
    }
  }]);

  return RoundRobin;
}();

RoundRobin.enabled = true;
export default RoundRobin;